import type { EnemyConfig } from '../../entities/EnemyConfig';

export const BEETLE_CONFIG: EnemyConfig = {
  id: 'beetle',
  displayName: 'Жук в панцире',
  maxHp: 1,
  speed: 40,
  movementBehavior: 'chase',
  size: 18,
  color: 0x4a6b2a,
  invulnerabilityColor: 0x3a3a4a,
  invulnerabilityCycle: {
    openMs: 2000,
    closedMs: 1500,
  },
  shellTextureKey: 'beetle_shell',
  // Жук съёживается под панцирь — на 20% меньше когда закрыт. Возврат к 1.0
  // происходит на open-фазе через resizeSpriteToConfig (без spec'а).
  shellScale: 0.8,
  scoreReward: 8,
};
